// smartreader-frontend/src/services/api.js
import axios from 'axios';
import { parseError } from '../api/error';

const API_KEY = process.env.REACT_APP_API_KEY;
const RAW_BASE_URL = process.env.REACT_APP_API_URL || '';
const BASE_URL = `${RAW_BASE_URL.replace(/\/?api\/?$/, '')}/api`;

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Enable sending cookies with requests
});

// Request interceptor for API key injection
// JWT tokens are sent automatically via httpOnly cookies — no localStorage tokens
api.interceptors.request.use(
  (config) => {
    if (API_KEY) {
      config.headers['x-api-key'] = API_KEY;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor for error handling + session expiry detection
api.interceptors.response.use(
  (response) => response,
  (error) => {
    error.apiError = parseError(error.response);
    if (error.response) {
      const status = error.response.status;

      // Session expired (unauthenticated) — notify AuthContext to logout.
      // 403 is authenticated-but-forbidden (RBAC denial, e.g. a scoped role
      // like report-viewer hitting an out-of-scope endpoint) and must NOT log
      // the user out, or any allow-list gap kicks them back to the login page.
      if (status === 401) {
        window.dispatchEvent(new Event('auth:expired'));
        error.userMessage = 'Session expired. Please sign in again.';
      } else if (status >= 400 && status < 500) {
        error.userMessage =
          error.apiError?.message || 'Request failed. Please check your input.';
      } else if (status >= 500) {
        error.userMessage = 'Server error. Please try again later.';
      }
    } else {
      error.userMessage = 'Network error. Please check your connection.';
    }
    return Promise.reject(error);
  },
);

export const getBaseUrlWithoutApi = () => {
  const baseURL = api.defaults.baseURL || '';
  // Robustly remove a trailing "/api" or "/api/" if present
  return baseURL.replace(/\/api\/?$/, '');
};
export default api;
